import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';

export default class extends Controller {
  connect() {
    this.handlingUnauthorized = false;
  }

  async intercept( event ){
    const response = event.detail.fetchResponse.response;

    if( response.status === 401 && response.headers.get( 'X-CSRF-Expired' ) === 'true' ){
      event.preventDefault();
      await this.refreshCSRFToken();
      return;
    }

    if( response.url.match( "/u/login" ) ){
      // Intercept unauthorized redirect in turbo frame request.
      event.preventDefault();
      // To redirect the user back after a successful authorization. The url before signing out
      // here, is the turbo frame request, which is part of the the current page.
      //
      // Reload instead of assigning window.location.href, reassigning the current url only moves
      // the hash when the page has one ( ex. /instances/{{lab_url}}#presentation ), so the page
      // would never navigate and the session lock overlay shows up instead.
      window.location.reload();
    }
  }

  async refreshCSRFToken(){
    if( this.handlingUnauthorized ) return;

    this.handlingUnauthorized = true;

    try {
      const response = await get( '/csrf_meta_reset', {
        responseKind: 'json',
      } );

      if( !response.ok ) throw new Error( 'CSRF token refresh failed' );

      const data = await response.json;
      this.updateCSRFToken( data );
    } catch( _error ) {
      window.toastr.error( 'Your session has expired. Please refresh the page and try again.' );
    } finally {
      this.handlingUnauthorized = false;
    }
  }

  updateCSRFToken( data ){
    const paramMeta = document.querySelector( 'meta[name="csrf-param"]' );
    const tokenMeta = document.querySelector( 'meta[name="csrf-token"]' );
    const oldParam = paramMeta ? paramMeta.getAttribute( 'content' ) : 'authenticity_token';

    if( paramMeta ) paramMeta.setAttribute( 'content', data.param );
    if( tokenMeta ) tokenMeta.setAttribute( 'content', data.token );

    [ oldParam, data.param ].forEach( function( param ){
      document.querySelectorAll( `input[name="${param}"]` ).forEach( function( input ){
        input.value = data.token;
      } );
    } );
  }
}
